import { render, staticRenderFns } from "./QuizCard.vue?vue&type=template&id=34d7414a&scoped=true"
import script from "./QuizCard.vue?vue&type=script&lang=js"
export * from "./QuizCard.vue?vue&type=script&lang=js"
import style0 from "./QuizCard.vue?vue&type=style&index=0&id=34d7414a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d7414a",
  null
  
)

export default component.exports